import { useRouter } from "next/router";
import config from "@/lib/config";
import routes from "./routes";
export default function isShowValuePlanLabel(_ref) {
  var channelId = _ref.channelId;
  var router = useRouter();
  var valuePlanId = config.valuePlanId.vod;
  var showValuePlanLabel = channelId === valuePlanId && router.asPath !== routes.valuePlan;
  return showValuePlanLabel;
}